import AuthDialog from "@/components/auth-dialog";
import { useState } from "react";
import { Menu, X, HandCoins } from "lucide-react";
import ModeToggle from "@/components/mode-toggle";
import { RouterLink } from "./routing/router-link";

export default function PublicLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  return (
    <div className="h-[100vh] bg-gradient-to-b from-primary antialiased">
      <div className="min-h-[100vh] flex flex-col">
        {/* Navigation */}
        <nav className="container mx-auto px-4 py-4 flex justify-between items-center relative">
          <RouterLink
            route={{
              path: "/",
            }}
            className="flex items-center"
          >
            <div className="w-8 h-8 bg-blue-600 rounded-full mr-2 flex items-center justify-center border border-white">
              <HandCoins className="text-white w-4 h-4" />
            </div>
            <span className="text-xl font-bold text-white">Pay4Delay</span>
          </RouterLink>

          {/* Mobile Menu Toggle */}
          <div className="md:hidden">
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className=""
            >
              {mobileMenuOpen ? <X /> : <Menu />}
            </button>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-4">
            {/* <RouterLink
              route={{ path: "/faq" }}
              className="hover:text-blue-200 transition"
            >
              FAQ
            </RouterLink> */}
            <RouterLink
              route={{ path: "/how-it-works" }}
              className="hover:text-blue-200 transition"
            >
              Jak działamy
            </RouterLink>
            <AuthDialog>Zaczynamy</AuthDialog>
            <ModeToggle />
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="absolute top-full left-0 w-full h-[100vh] bg-gradient-to-b from-primary to-secondary antialiased md:hidden text-lg font-bold">
              <div className="flex flex-col items-center space-y-4 py-6">
                <RouterLink
                  route={{ path: "/faq" }}
                  className="hover:text-blue-200"
                >
                  FAQ
                </RouterLink>
                <RouterLink
                  route={{ path: "/how-it-works" }}
                  className="hover:text-blue-200"
                >
                  Jak działamy
                </RouterLink>
                <AuthDialog>Zaczynamy</AuthDialog>
                <ModeToggle />
                <RouterLink
                  route={{ path: "/privacy" }}
                  className="hover:text-blue-200 transition"
                >
                  Polityka prywatności
                </RouterLink>
                <RouterLink
                  route={{ path: "/terms" }}
                  className="hover:text-blue-200 transition"
                >
                  Regulamin i warunki
                </RouterLink>
                <RouterLink
                  route={{ path: "/contact" }}
                  className="hover:text-blue-200 transition"
                >
                  Kontakt
                </RouterLink>
              </div>
            </div>
          )}
        </nav>

        <main className="mx-auto px-4 md:px-8 flex-1">{children}</main>
        {/* Footer */}
        <footer className="text-sm container mx-auto px-4 py-6 text-center">
          <p className="py-2">
            © 2025 Pay4Delay. Odszkodowania za opóźnienia pociągów.
          </p>
          <div className="md:flex items-center space-x-4 w-full justify-center">
            <RouterLink
              route={{ path: "/privacy" }}
              className="hover:text-blue-200 transition"
            >
              Polityka prywatności
            </RouterLink>
            <RouterLink
              route={{ path: "/terms" }}
              className="hover:text-blue-200 transition"
            >
              Regulamin i warunki
            </RouterLink>
            <RouterLink
              route={{ path: "/contact" }}
              className="hover:text-blue-200 transition"
            >
              Kontakt
            </RouterLink>
            <RouterLink
              route={{ path: "/faq" }}
              className="hover:text-blue-200 transition"
            >
              FAQ
            </RouterLink>
          </div>
        </footer>
      </div>
    </div>
  );
}
